<template>
  <div id="app">
    <router-view></router-view>
    <!-- Ensure this is present if using Vue Router -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Add some basic styles */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
